(() => {
  const keys = ['_pos', '_fid', '_ss'];
  const attrs = ['href', 'data-url', 'data-product-url', 'data-compare-toggle'];
  const selector = attrs.map(a => `[${a}*="/products/"]`).join(',');
  function clean(raw) {
    if (!raw || !keys.some(k => raw.includes(k + '='))) return raw;
    try {
      const url = new URL(raw, location.origin);
      if (url.origin !== location.origin || !/\/products\/[^/]+\/?$/.test(url.pathname)) return raw;
      keys.forEach(k => url.searchParams.delete(k));
      return raw.startsWith('/') && !raw.startsWith('//') ? url.pathname + url.search + url.hash : url.href;
    } catch (_) { return raw; }
  }
  function update(el) {
    attrs.forEach(attr => {
      const raw = el.getAttribute(attr), next = clean(raw);
      if (next !== raw) el.setAttribute(attr, next);
    });
  }
  function scan(root) {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.matches?.(selector)) update(root);
    root.querySelectorAll(selector).forEach(update);
  }
  scan(document);
  new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'attributes') update(record.target);
      else record.addedNodes.forEach(scan);
    }
  }).observe(document.documentElement, {subtree: true, childList: true, attributes: true, attributeFilter: attrs});
})();
